import isValidEmailAddress from "../validations/is.valid.email.address";

export default (values, value, type) => isValidEmailAddress(value);
